import {Backdrop, CircularProgress} from "@material-ui/core";

export const Loading = () => {
    return (
        <Backdrop open={true} style={{zIndex: 2000}}>
            <CircularProgress color="inherit" />
        </Backdrop>
    )
}
